export const BLOG_CATEGORIES = [
  {
    code: 'documents',
    icon: 'documents',
    label: 'Documentos',
    labels: { ES: 'Documentos', EN: 'Documents' },
  },
  {
    code: 'culture',
    icon: 'culture',
    label: 'Cultura',
    labels: { ES: 'Cultura', EN: 'Culture' },
  },
  {
    code: 'gastronomy',
    icon: 'gastronomy',
    label: 'Gastronomía',
    labels: { ES: 'Gastronomía', EN: 'Gastronomy' },
  },
  {
    code: 'brewery',
    icon: 'brewery',
    label: 'Cervecería',
    labels: { ES: 'Cervecería', EN: 'Brewery' },
  },
  {
    code: 'tourism',
    icon: 'tourism',
    label: 'Turismo',
    labels: { ES: 'Turismo', EN: 'Tourism' },
  },
  {
    code: 'history',
    icon: 'history',
    label: 'Historia',
    labels: { ES: 'Historia', EN: 'History' },
  },
  {
    code: 'medical',
    icon: 'medical',
    label: 'Médico',
    labels: { ES: 'Médico', EN: 'Medical' },
  },
];

const ICON_BASE = '/blog-categories';

/** Legacy Spanish filenames → current codes (older saved blogs). */
const LEGACY_ICON_TO_CODE = {
  documentos: 'documents',
  cultura: 'culture',
  gastronomia: 'gastronomy',
  cerveceria: 'brewery',
  turismo: 'tourism',
  historia: 'history',
  medico: 'medical',
};

export function getBlogCategoryIconSrc(iconOrCode) {
  if (!iconOrCode) return null;
  if (iconOrCode.startsWith('http') || iconOrCode.startsWith('/')) return iconOrCode;
  const code = LEGACY_ICON_TO_CODE[iconOrCode] || iconOrCode;
  return `${ICON_BASE}/${code}.svg`;
}

export function getBlogCategoryLabel(category, lang = 'ES') {
  if (!category) return '';
  const langKey = String(lang || 'ES').toUpperCase();
  if (category.labels?.[langKey]) return category.labels[langKey];
  if (category.labels?.ES) return category.labels.ES;
  if (category.labels?.EN) return category.labels.EN;
  return category.label || '';
}

function normalizeLookup(value = '') {
  return String(value)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function resolveBlogCategory(category) {
  if (!category) return null;

  const rawCode = category.code || LEGACY_ICON_TO_CODE[category.icon] || category.icon;
  if (rawCode) {
    const byCode = BLOG_CATEGORIES.find((c) => c.code === rawCode || c.icon === rawCode);
    if (byCode) return byCode;
  }

  const label = normalizeLookup(category.label);
  if (label) {
    const byLabel = BLOG_CATEGORIES.find((c) =>
      Object.values(c.labels).some((l) => normalizeLookup(l) === label)
    );
    if (byLabel) return byLabel;
  }

  if (category.label || category.code || category.icon) {
    return {
      code: category.code || category.icon || '',
      icon: category.icon || category.code || null,
      label: category.label || '',
      labels: category.labels || undefined,
    };
  }
  return null;
}

/** Payload shape persisted on hero.category */
export function toSavedBlogCategory(option, lang = 'ES') {
  if (!option?.code) return { code: '', label: '', icon: '' };
  const label = getBlogCategoryLabel(option, lang);
  return {
    code: option.code,
    icon: option.icon || option.code,
    label,
  };
}
